export enum IncentiveStatus {
  autoSelectedNonStackable = 'autoSelectedNonStackable',
  autoSelectedApplied = 'autoSelectedApplied',
  autoApplied = 'autoApplied', // Auto-applied by system and returned back in lender program as applied
  applied = 'applied', // selected by user and returned back in lender program as applied
  nonStackable = 'nonStackable', // selected by user but not returned back in lender program as applied
  notApplied = 'notApplied', // not selected by user
  loading = 'loading', // loading status. Used when we are waiting for response from server
}
